import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  UPLOAD_IMAGE_SUCCESS,
  IMAGE_UPLOADING_SUCCESS,
  UPDATE_THEME_PREFERENCES_SUCCESS,
  UPDATE_THEME_SUCCESS,
  FETCH_NOTIFICATION_SUCCESS
} from "../sagas/userMenu/userMenu";

export const actionCreators = {};

export const initialState = {
  currentUser: {},
  notification: {},
  lightTheme: false,
  isLoading: true,
  imageUploading: false
};

export default handleActions(
  {
    [IMAGE_UPLOADING_SUCCESS]: (state, action) => ({
      ...state,
      imageUploading: action.payload
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload || state.isLoading
    }),

    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      lightTheme: action.payload.theme !== "dark"
    }),

    [FETCH_NOTIFICATION_SUCCESS]: (state, action) => {
      return {
        ...state,
        notification: action.payload
      };
    },
    [UPLOAD_IMAGE_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      imageUploading: false
    }),
    [UPDATE_THEME_SUCCESS]: (state, action) => ({
      ...state,
      lightTheme: action.payload.theme !== "dark"
    }),
    [UPDATE_THEME_PREFERENCES_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      lightTheme: action.payload.theme !== "dark"
    })
  },
  initialState
);
